// The Build/Brand sequence + stage gates (docs/phase-0/slice5-ux-flows.md §2.1). Both
// gates are server-side and default-deny (D36, CLAUDE.md §0 non-negotiable #1) - this
// is UI CONVENIENCE only, selecting which takeover/redirect renders; the server
// re-checks readiness at the seam regardless (`StageReadiness`,
// packages/shared/src/model/build.ts:21-31; ADR-0021 decision 3, "keep derived state
// acyclic" per app-engineering §2). Mirrors apps/web/src/certify/gate.ts's own
// precedent (evaluateCertifyGate) for the same "client reads state to pick CTA copy,
// never to decide the gate" discipline.
import type { AppStage, AppVerdict } from "@nightcrew/shared";

/**
 * True once the founder has an affirmative verdict to build a brand from (D6, ux spec
 * §2.1, §6.2's own sequence-guard note): a naive "verdict !== 'none'" check would
 * wrongly admit a `conditional` verdict straight to Brand without ever showing the
 * three-path chooser, so this is an explicit allow-list of the two go-forward
 * outcomes (`passed`, `unvalidated` after "build anyway"), not a not-equal check.
 */
export const canEnterBrand = (verdict: AppVerdict): boolean =>
  verdict === "passed" || verdict === "unvalidated";

/** Production Build's stage gate (D34, ux spec §9): reuses `LifecycleGateCard` when false. */
export const canEnterProductionBuild = (stage: AppStage): boolean => stage === "mvp";
